import { trigger, transition, animate, style } from '@angular/animations';

export const fadeIn = trigger('fadeIn', [
  transition(':enter', [style({ opacity: '0' }), animate('100ms linear', style({ opacity: '1' }))]),
  transition(':leave', [style({ opacity: '1' }), animate('300ms  linear', style({ opacity: '0' }))]),
]);
